import en from './en'
import ru from './ru'
import zh from './zh'
import ja from './ja'

export default { en, ru, zh, ja }



// WEBPACK FOOTER //
// ./app/javascript/components/locales/data.js